import { Color, Icon, NavListItemText } from '@billy/design-system'
import { ReactElement, useCallback } from 'react'
import { useTranslation } from 'react-i18next'
import { useMatch, useNavigate } from 'react-router'

import { useUserOrganization } from '@modules-deprecated/app/organization'

import { getOrganizationViewUrl } from '../../../../utils/routing/getOrganizationViewUrl'
import { reactRoute } from '../../../../utils/routing/reactRoute'
import { useDmsUserRole } from '../../hooks/useDmsUserRole'
import * as Styled from './styles'

export const SharedByMeNavItem = (): ReactElement | null => {
  const { t } = useTranslation()
  const navigate = useNavigate()
  const { organization } = useUserOrganization()
  const { isLoading, isCpaExpertMode, isBoWithoutCpa } = useDmsUserRole()

  const sharedByMeRoute = reactRoute.organization.clientDocuments.getSharedByMeRoute()
  const sharedByMeUrl = organization ? getOrganizationViewUrl(organization.url, sharedByMeRoute) : ''
  const isSharedByMeRouteActive = !!useMatch(sharedByMeUrl)

  const handleNavItemClick = useCallback(() => {
    if (sharedByMeUrl) {
      navigate(sharedByMeUrl)
    }
  }, [navigate, sharedByMeUrl])

  if (isLoading || isCpaExpertMode || isBoWithoutCpa) {
    return null
  }

  return (
    <Styled.NavItemWrapper>
      <Styled.NavItem $isSelected={isSharedByMeRouteActive} onClick={handleNavItemClick}>
        <Icon color={Color.Grey700} icon="layers" size="sm" />
        <NavListItemText>{t('documents.shared_by_me.nav_label')}</NavListItemText>
      </Styled.NavItem>
    </Styled.NavItemWrapper>
  )
}
